import React from "react"

import { PagerWrap } from "./pager.styled"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"

/**
 * Pager component for navigating through slides.
 *
 * This component renders a navigation bar with buttons to navigate to the previous and next slides.
 * It also displays the current slide information. The `ArrowRight` icon is used for both navigation buttons
 *
 * Props:
 * - `nextSlide`: Function to navigate to the next slide.
 * - `prevSlide`: Function to navigate to the previous slide.
 * - `text`: Text to display for the current slide (e.g., "01 / 06").
 *
 * Usage:
 * <Pager nextSlide={handleNextSlide} prevSlide={handlePrevSlide} text="01 / 06" />
 */
const Pager = ({
  nextSlide,
  prevSlide,
  text,
  cls = ``,
  textCls = `text-nova-transparency-black-60 Caption-10-Dia-Uppercase text-center`,
}) => {
  return (
    <nav aria-label="Pages navigation" className={`pager-nav`}>
      <PagerWrap className={cls}>
        <li aria-label="Previous Page">
          <ButtonNova
            onClick={prevSlide}
            className={`left-arrow`}
            level={`Tertiary`}
            icon={`Only`}
          />
        </li>
        <li>
          <TextElementNova text={text} className={textCls} />
        </li>
        <li aria-label="Next Page">
          <ButtonNova
            onClick={nextSlide}
            level={`Tertiary`}
            icon={`Only`}
            className={`right-arrow`}
          />
        </li>
      </PagerWrap>
    </nav>
  )
}

export default Pager
